<template>
  <div class="quiz-view view" ref="quizView">
    <div class="quiz-content-view content-view" v-if="misfit != null" ref="quizContentViewEl">
      <div class="qc-misfit-type">{{misfit.type}}</div>
      <div class="qc-time">
        <div class="qc-time-bg"></div>
        <div class="qc-time-label">{{timerLeft}}</div>
      </div>

      <!-- <transition
        @enter="enter"
        @beforeEnter="beforeEnter"
        mode="out-in"
      > -->
      <transition
        name="fade"
      >
        <div
          class="qc-content qc-memorize"
          v-if="currentQuizState == quizStateMemorize"
          ref="qcMemorize"
          key="qcMemorize"
        >
          <div class="qc-content-animation-container" ref="qcMemorizeAnimationContainer">
            <div class="qc-memorize-misfit-gummie"><img :src="misfit.assetURL" :alt="flavorOne.label + '+' + flavorTwo.label" /></div>
            <div class="qc-memorize-label qc-content-label">Memorize the 2 flavours before timer runs out!</div>
            <div class="qc-memorize-question">
              <!-- <div class="qc-flavor-container flavor-one">
                <div class="qc-flavor-image"><img :src="flavorOne.assetURL" :alt="flavorOne.label" /></div>
                <div class="qc-memorize-flavor-label">{{flavorOne.label}}</div>
              </div> -->
              <QuizFlavorImage
                :class="['flavor-one']"
                :imageAssetURL="flavorOne.assetURL"
                :imageAltText="flavorOne.label"
              >
                <div class="qc-memorize-flavor-label">{{flavorOne.label}}</div>
              </QuizFlavorImage>
              <div class="qc-memorize-flavor-plus">+</div>
              <!-- <div class="qc-flavor-container flavor-two">
                <div class="qc-flavor-image"><img :src="flavorTwo.assetURL" :alt="flavorTwo.label" /></div>
                <div class="qc-memorize-flavor-label">{{flavorTwo.label}}</div>
              </div> -->
              <QuizFlavorImage
                :class="['flavor-two']"
                :imageAssetURL="flavorTwo.assetURL"
                :imageAltText="flavorTwo.label"
              >
                <div class="qc-memorize-flavor-label">{{flavorTwo.label}}</div>
              </QuizFlavorImage>
            </div>

            <Button
              :class="'next-btn'"
              :label="'NEXT'"
              @clicked="handleMemorizeNextBtnClicked"
            />
          </div>
        </div>
        <div
          class="qc-content qc-select"
          v-else-if="currentQuizState == quizStateSelect || currentQuizState == quizStateTryAgain"
          ref="qcSelect"
          key="qcSelect"
        >
          <div class="qc-content-animation-container" ref="qcSelectAnimationContainer">
            <div class="qc-memorize-misfit-gummie" ref="qcMemorizeMisfitGummie">
              <div class="qc-memorize-gummie-sparkle">
                <div class="qc-sparkle qc-sparkle-1" ref="qcSparkle1"></div>
                <div class="qc-sparkle qc-sparkle-2" ref="qcSparkle2"></div>
                <div class="qc-sparkle qc-sparkle-1" ref="qcSparkle3"></div>
                <div class="qc-sparkle qc-sparkle-2" ref="qcSparkle4"></div>
              </div>
              <img :src="quizCorrect ? misfit.assetURL : misfit.quizOutlineAssetURL" :alt="misfit.label" />
            </div>

            <transition name="fade">
              <div
                class="qc-select-content"
                v-if="currentQuizState == quizStateSelect"
                ref="qcSelectQuizContent"
                key="qcSelectQuizContent"
              >
                <div
                  class="qc-select-animation-container"
                  ref="qcSelectQuizAnimationContainer"
                >
                  <div class="qc-select-label qc-content-label">Select the 2 correct flavours before timer runs out!</div>
                  <div class="qc-select-flavors">
                    <!-- <div
                      v-for="(flavor, index) in flavorQuizOptions.slice(0, 5)"
                      :class="[
                        'qc-select-flavor-item qc-flavor-container',
                        isFlavorSelected(flavor.id) ? 'selected' : ''
                      ]"
                      @click="handleFlavorClicked(index, flavor)"
                      ref="flavorOptions"
                      :key="'flavorOption'+index"
                    >
                      <div class="qc-flavor-image"><img :src="flavor.assetURL" :alt="flavor.label" /></div>
                    </div> -->

                    <QuizFlavorImage
                      v-for="(flavor, index) in flavorQuizOptions.slice(0, 5)"
                      :class="[
                        'qc-select-flavor-item',
                      ]"
                      :imageAssetURL="flavor.assetURL"
                      :imageAltText="flavor.label"
                      :selected="isFlavorSelected(flavor.id)"
                      @clicked="handleFlavorClicked(index, flavor)"
                      ref="flavorOptions"
                      :key="'flavorOption'+index"
                    >
                    </QuizFlavorImage>

                  </div>
                  <div class="qc-select-picked-flavors-container">
                    <!-- <div class="qc-flavor-container picked-flavor-one" ref="pickedFlavorOneEl">
                      <div class="qc-flavor-image"><img :src="pickedFlavors[0].assetURL" /></div>
                      <div class="qc-flavor-wrong-black-overlay" :style="[pickedFlavorOneWrongOverlayStyle]"></div>
                      <div class="qc-flavor-wrong-overlay"></div>
                    </div> -->
                    <QuizFlavorImage
                      :class="[
                        'picked-flavor-one',
                        pickedFlavors[0].wrong ? 'wrong' : '',
                      ]"
                      :imageAssetURL="pickedFlavors[0].assetURL"
                      ref="pickedFlavorOneEl"
                    >
                      <div class="qc-flavor-wrong-black-overlay" :style="[pickedFlavorOneWrongOverlayStyle]"></div>
                      <div class="qc-flavor-wrong-overlay"></div>
                    </QuizFlavorImage>
                    <div class="qc-memorize-flavor-plus">+</div>
                    <!-- <div class="qc-flavor-container picked-flavor-two" ref="pickedFlavorTwoEl">
                      <div class="qc-flavor-image"><img :src="pickedFlavors[1].assetURL" /></div>
                      <div class="qc-flavor-wrong-black-overlay" :style="[pickedFlavorTwoWrongOverlayStyle]"></div>
                      <div class="qc-flavor-wrong-overlay"></div>
                    </div> -->
                    <QuizFlavorImage
                      :class="[
                        'picked-flavor-two',
                        pickedFlavors[1].wrong ? 'wrong' : '',
                      ]"
                      :imageAssetURL="pickedFlavors[1].assetURL"
                      ref="pickedFlavorTwoEl"
                    >
                      <div class="qc-flavor-wrong-black-overlay" :style="[pickedFlavorTwoWrongOverlayStyle]"></div>
                      <div class="qc-flavor-wrong-overlay"></div>
                    </QuizFlavorImage>
                  </div>

                  <!-- <Button
                    v-if="quizCorrect === true"
                    :class="'next-btn'"
                    :label="'NEXT'"
                    @clicked="handleSelectNextBtnClicked"

                  /> -->
                </div>
              </div>
              <div
                class="qc-select-content"
                v-else-if="currentQuizState == quizStateTryAgain"
                ref="qcSelectSorryContent"
                key="qcSelectSorryContent"
              >
                <div
                  class="qc-select-animation-container"
                  ref="qcSelectSorryAnimationContainer"
                >
                  <div class="qc-try-again-label">
                    SORRY.<br />
                    YOUR TIME HAS RUN OUT!<br />
                    PLEASE TRY AGAIN.
                  </div>
                  <Button
                    :class="'start-over-btn'"
                    :label="'START OVER'"
                    @clicked="handleTryAgainStartOverBtnClicked"
                  />
                </div>
              </div>
            </transition>
          </div>
        </div>
        <!-- <div
          class="qc-content qc-try-again"
          v-else-if="currentQuizState == quizStateTryAgain"
          ref="qcTryAgain"
          key="qcTryAgain"
        >
          <div class="qc-content-animation-container" ref="qcTryAgainAnimationContainer">
            <div class="qc-try-again-misfit-gummie"><img :src="misfit.quizOutlineAssetURL" :alt="misfit.label" /></div>
            <div class="qc-try-again-label">
              SORRY.<br />
              YOUR TIME HAS RUN OUT!<br />
              PLEASE TRY AGAIN.
            </div>
            <Button
              :class="'start-over-btn'"
              :label="'START OVER'"
              @clicked="handleTryAgainStartOverBtnClicked"
            />
          </div>
        </div> -->
      </transition>
    </div>

  </div>
</template>

<script>
import { ref, computed, watch, onMounted, onBeforeUpdate } from '@vue/composition-api';
import gsap from 'gsap';
import Button from '@/components/Button.vue';
import QuizFlavorImage from '@/components/QuizFlavorImage.vue';

import assetQuizFlavorOutline from '@/assets/images/quiz/quiz_flavor_outline.png';
import assetQuizFlavorWrongSlash from '@/assets/images/quiz/quiz_flavor_wrong_slash.png';
import assetFlavorSelectedInnerShadow from '@/assets/images/flavor_selected_inner_shadow.png';


const NAMESPACE = '[Quiz]';
const DEBUG = false;

let defaultTime = 5;

export default {
  name: 'Quiz',
  components: {
    Button,
    QuizFlavorImage,
  },

  setup(props, context) {
    const {
      $router,
      $store
    } = context.root;

    // Properties
    const quizFlavorOutlineImage = ref(assetQuizFlavorOutline);
    const quizFlavorWrongSlashImage = ref(assetQuizFlavorWrongSlash);
    const flavorSelectedInnerShadowImage = ref(assetFlavorSelectedInnerShadow);

    const quizStateMemorize = ref('QUIZ_STATE_MEMORIZE');
    const quizStateSelect = ref('QUIZ_STATE_SELECT');
    const quizStateTryAgain = ref('QUIZ_STATE_TRY_AGAIN');

    const currentQuizState = ref(null);
    // const misfit = ref(null);
    const misfit = computed(() => {
      return $store.getters['product/getMisfitById']($store.state.user.quizMisfitId);
    })
    const pickedFlavors = ref([]);
    const pickedFlavorOneWrongOverlayStyle = ref({opacity: 0.6});
    const pickedFlavorTwoWrongOverlayStyle = ref({opacity: 0.6});
    const quizCorrect = ref(false);
    const quizEnded = ref(false);

    const flavorOne = computed(() => {
      console.log('compute flavorOne');
      console.log(misfit.value)
      if( misfit.value != null ) {
        console.log(misfit.value.flavors[0]);
        return getMisfitFlavor(misfit.value.flavors[0]);
      //   // return getMisfitFlavor(misfit.flavors[1]);
      }

      return null;
    });
    const flavorTwo = computed(() => {
      console.log('compute flavorTwo');
      if( misfit.value != null ) {
        console.log(misfit.value.flavors[1]);
        return getMisfitFlavor(misfit.value.flavors[1]);
      }

      return null;
    });
    const flavorQuizOptions = computed(() => {
      if( misfit.value != null ) {
        return $store.getters['product/getFlavorOptionsForMisfit'](misfit.value.id);
      }

      return [];
    })

    // References
    const quizView = ref(null);
    const quizContentViewEl = ref(null);


    const flavorOptions = ref([]);
    const pickedFlavorOneEl = ref(null);
    const pickedFlavorTwoEl = ref(null);



    // const quizId = $store.getters['user/getQuizMisfitId'];
    const quizId = $store.state.user.quizMisfitId;
    console.log('quizId:', quizId);

    // watch()

    /**
     * Vue Hooks
     */
    // onBeforeUpdate(() => {
    //   flavorOptions.value = [];
    //   qcSelect.value = null;
    //   qcMemorize.value = null;
    // });

    onMounted(() => {
      console.log(NAMESPACE, 'onMounted()');

      const currentMisfit = $store.getters['product/getMisfitById'](quizId);
      console.log('currentMisfit:', currentMisfit);

      // console.log(beforeEnter);

      // console.log('quizView:', quizView);
      // console.log(quizView.value);
      // console.log('qcSelect:', qcSelect.value);
      // console.log('flavorOptions:', flavorOptions.value);


      // getMisfitFlavor(13);
      // const options = $store.getters['product/getFlavorOptionsForMisfit'](quizId);
      // console.log(options);

      context.root.$nextTick(() => {
        console.log('onMounted nextTick');

        // misfit.value = currentMisfit;
        currentQuizState.value = quizStateMemorize.value;

        context.root.$nextTick(() => {
          startMemorizeState();
          // startSelectState();
          // startTryAgainState();
        })
      })
    });

    /**
     * Methods
     */
    const getMisfitFlavor = (id) => {
      const misfitFlavor = $store.getters['product/getMisfitFlavorById'](id);

      console.log(misfitFlavor);

      if( misfitFlavor != null ) {
        console.log('id:', misfitFlavor.id);
        console.log('label:', misfitFlavor.label);
        console.log('assetURL:', misfitFlavor.assetURL);
      }

      return misfitFlavor;
    }

    const isFlavorSelected = (id) => {
      for( let i=0; i<pickedFlavors.value.length; i++ ) {
        if( pickedFlavors.value[i].flavorId === id ) {
          return true;
        }
      }

      return false;
    }


    /**
     * Quiz Memorize State
     */
    const qcMemorize = ref(null);
    const qcMemorizeAnimationContainer = ref(null);
    const qcMemorizeMisfitGummie = ref(null);

    const handleMemorizeNextBtnClicked = () => {
      console.log(NAMESPACE, 'handleMemorizeNextBtnClicked()');

      startSelectState();
    }

    const startMemorizeState = () => {
      console.log(NAMESPACE, 'startMemorizeState()');

      currentQuizState.value = quizStateMemorize.value;
      console.log('currentQuizState:', currentQuizState.value);

      if( !DEBUG ) {
        startTimer(defaultTime);
      }

      console.log(new Date().getTime())
      context.root.$nextTick(() => {
        console.log('startMemorizeState nextTick');
        console.log(new Date().getTime())

        console.log('qcMemorizeAnimationContainer:', qcMemorizeAnimationContainer.value);

        resizeContentEl(qcMemorizeAnimationContainer);

        // let intervalId = setInterval(() => {
        //   console.log('still null');
        //   if( qcMemorizeAnimationContainer.value != null ) {
        //     clearInterval(intervalId);
        //     resizeContentEl(qcMemorizeAnimationContainer);
        //   }
        // }, 100);
        // resizeContentEl(qcMemorizeAnimationContainer);

        // try {
        //   resizeContentEl(qcMemorizeAnimationContainer);
        // } catch(e) {
        //   setTimeout(() => {
        //     resizeContentEl(qcMemorizeAnimationContainer);
        //   }, 500);
        // }
      })
    }



    /**
     * Quiz Select State
     */
    const qcTryAgain = ref(null);
    const qcSelect = ref(null);
    const qcSelectAnimationContainer = ref(null);

    const qcSelectQuizAnimationContainer = ref(null);
    const qcSelectSorryAnimationContainer = ref(null);
    const qcTryAgainAnimationContainer = ref(null);

    const qcSparkle1 = ref(null);
    const qcSparkle2 = ref(null);
    const qcSparkle3 = ref(null);
    const qcSparkle4 = ref(null);


    /**
     * Quiz Select State References
     */
    const handleSelectNextBtnClicked = () => {
      console.log(NAMESPACE, 'handleSelectNextBtnClicked()');

      // // Testing states
      // startTryAgainState();
      // return;

      if( quizEnded.value === true ) {
        $router.push({path:'/result'});
      } else {
        let answer = checkAnswers();


      }
    }

    const handleTryAgainStartOverBtnClicked = () => {
      startMemorizeState();
    }

    const handleFlavorClicked = (index, flavor) => {
      if( quizEnded.value ) {
        return;
      }

      console.log('handleFlavorClicked', flavor.id);

      // if( pickedFlavors.length < 2 ) {
        togglePickedFlavor(index, flavor);
      // } else {
      //   // you can't pick a flavor anymore since 2 are already selected
      // }
    }

    const startSelectState = () => {
      console.log(NAMESPACE, 'startSelectState()');

      stopTimer();

      currentQuizState.value = quizStateSelect.value;
      quizCorrect.value = false;
      quizEnded.value = false;

      pickedFlavors.value = [
        {
          flavorId: null,
          assetURL: assetQuizFlavorOutline,
          wrong: false,
        },
        {
          flavorId: null,
          assetURL: assetQuizFlavorOutline,
          wrong: false,
        },
      ];

      pickedFlavorOneWrongOverlayStyle.value.opacity = 0.6;
      pickedFlavorTwoWrongOverlayStyle.value.opacity = 0.6;

      if( !DEBUG ) {
        startTimer(defaultTime*2);
      }

      context.root.$nextTick(() => {
        console.log('startSelectState nextTick');

        resizeContentEl(qcSelectAnimationContainer);
        resizeSelectContentEl(qcSelectQuizAnimationContainer);
      })
    }

    const togglePickedFlavor = (index, flavor) => {
      let flavorId = flavor.id;
      console.log(NAMESPACE, 'togglePickedFlavor');
      console.log('index:', index);
      console.log('flavorId:', flavorId);

      // console.log(qcSelect);
      // console.log(qcSelect.value);
      // console.log(flavorOptions);
      // console.log(flavorOptions.value.length);


      let found = false;

      for( let i=0; i<pickedFlavors.value.length; i++ ) {
        if( pickedFlavors.value[i].flavorId === flavorId ) {
          found = true;
          // flavorOptions.value[index].classList.remove('selected');

          pickedFlavors.value[i].flavorId = null;
          pickedFlavors.value[i].assetURL = assetQuizFlavorOutline;
          pickedFlavors.value[i].wrong = false;

          // Reset the wrong state for the index
          if( i === 0 ) {
            // pickedFlavorOneEl.value.classList.remove('wrong');
          } else {
            // pickedFlavorTwoEl.value.classList.remove('wrong');
          }
          break;
        }
      }

      console.log('found:', found);

      if( !found ) {
        console.log(flavorOptions);
        console.log(flavorOptions.value[index]);

        if( pickedFlavors.value[0].flavorId === null || (pickedFlavors.value[0].flavorId !== null && pickedFlavors.value[0].wrong === true) ) {
          console.log('update picked flavor 0 with ', flavorId);
          found = true;
          updatePickedFlavor(0, flavorId);
          pickedFlavorOneWrongOverlayStyle.value.opacity = flavor.wrongOverlayOpacity;
          // flavorOptions.value[index].classList.add('selected');
          // pickedFlavorOneEl.value.classList.remove('wrong');
        }

        if( !found && (pickedFlavors.value[1].flavorId === null || (pickedFlavors.value[1].flavorId !== null && pickedFlavors.value[1].wrong === true)) ) {
          console.log('update picked flavor 1 with ', flavorId);
          updatePickedFlavor(1, flavorId);
          pickedFlavorTwoWrongOverlayStyle.value.opacity = flavor.wrongOverlayOpacity;
          // flavorOptions.value[index].classList.add('selected');
          // pickedFlavorTwoEl.value.classList.remove('wrong');
        }

        // Update 4/13
        // If user has picked 2 flavors, automatically check for answer.
        if( pickedFlavors.value[0].flavorId !== null && pickedFlavors.value[1].flavorId !== null ) {
          checkAnswers();
        }

        // if( pickedFlavors.value[0].flavorId == 0)

        // pickedFlavors.value.push({
        //   flavorId: flavorId,
        // })
      }

      console.log(pickedFlavors.value);
    }

    const updatePickedFlavor = (index, flavorId) => {
      if(
        pickedFlavors.value[index].flavorId === null ||
        (pickedFlavors.value[index].flavorId !== null && pickedFlavors.value[index].wrong === true)
      ) {
        pickedFlavors.value[index].flavorId = flavorId;
        pickedFlavors.value[index].wrong = false;

        let flavor = getMisfitFlavor(flavorId);
        pickedFlavors.value[index].assetURL = flavor.assetURL;


      }
    }

    // Check the answers to see if flavors selected by users are correct.
    // If the flavors are not correct, mark them wrong.
    const checkAnswers = () => {
      console.log(NAMESPACE, 'checkAnswers()');

      console.log('flavorOne.id:', flavorOne.value.id);
      console.log('flavorTwo.id:', flavorTwo.value.id);

      let correct = true;

      for( let i=0; i<pickedFlavors.value.length; i++ ) {
        console.log('pickedFlavors '+i+' flavorId', pickedFlavors.value[i].flavorId);
        if( i === 0 ) {
          if( pickedFlavors.value[i].flavorId === flavorOne.value.id || pickedFlavors.value[i].flavorId === flavorTwo.value.id ) {
            pickedFlavors.value[i].wrong = false;
            // pickedFlavorOneEl.value.classList.remove('wrong');
          } else {
            pickedFlavors.value[i].wrong = true;
            // pickedFlavorOneEl.value.classList.add('wrong');
            correct = false;
          }
        } else {
          if( pickedFlavors.value[i].flavorId === flavorOne.value.id || pickedFlavors.value[i].flavorId === flavorTwo.value.id ) {
            pickedFlavors.value[i].wrong = false;
            // pickedFlavorTwoEl.value.classList.remove('wrong');
          } else {
            pickedFlavors.value[i].wrong = true;
            // pickedFlavorTwoEl.value.classList.add('wrong');
            correct = false;
          }
        }

      }

      if( correct === true ) {
        quizCorrect.value = true;
        quizEnded.value = true;
        stopTimer();

        showRightAnswerAnimation();

        $store.dispatch('user/setQuizResult', correct, {root:true});

        setTimeout(() => {
          $router.push({path:'/result'});
        }, 1000);
        // $router.push({path:'/result'});
      }

      return correct;
    }

    /**
     * Quiz Try Again
     */
    const startTryAgainState = () => {
      console.log(NAMESPACE, 'startTryAgainState');

      currentQuizState.value = quizStateTryAgain.value;

      context.root.$nextTick(() => {
        console.log('startSelectState nextTick');

        // resizeContentEl(qcTryAgainAnimationContainer);
        resizeSelectContentEl(qcSelectSorryAnimationContainer);
      })
    }

    /**
     * Timer section
     * Just a simple startTimer / endTimer for the quiz.
     * The current state can use this to start/stop the timer.
     * When timer ends, it check against the current state
     */
    const timerLeft = ref(defaultTime);
    const timerIntervalId = ref(null);

    function startTimer(seconds) {
      timerLeft.value = seconds;

      timerIntervalId.value = setInterval(() => {
        console.log('interval timer fired');
        timerLeft.value--;

        if( timerLeft.value <= 0 ) {
          stopTimer();
          handleTimerCompleted();
        }
      }, 1000);
    }

    function stopTimer() {
      clearInterval(timerIntervalId.value);
    }

    function handleTimerCompleted() {
      if( currentQuizState.value === quizStateMemorize.value ) {
        startSelectState();
      } else {
        // check to see if selected answers are correct or wrong
        // checkAnswers();
        startTryAgainState();
      }
    }



    // Resize
    function resizeContentEl(contentEl) {
      let contentRect = contentEl.value.getBoundingClientRect();
      let contentViewRect = quizContentViewEl.value.getBoundingClientRect();

      let contentHeight = contentViewRect.top + contentViewRect.height - contentRect.top;

      contentEl.value.style.height = contentHeight+'px';
    }

    function resizeSelectContentEl(contentEl) {
      let contentRect = contentEl.value.getBoundingClientRect();
      let contentViewRect = quizContentViewEl.value.getBoundingClientRect();
      let selectContentRect = qcSelectAnimationContainer.value.getBoundingClientRect();

      let contentHeight = selectContentRect.top + selectContentRect.height - contentRect.top;

      contentEl.value.style.height = contentHeight+'px';
    }

    // Animation
    const showRightAnswerAnimation = () => {
      let sparkle2EndY = misfit.value.type === 'MER-BEARS' ? 120 : 220;

      let rightAnswerTimeline = gsap.timeline({paused:true});
      rightAnswerTimeline.fromTo(qcSparkle1.value, {
        scale: (0.5 + (Math.random()*0.2) - Math.random()*0.2),
        rotation: 0,
        x: (0 + Math.random() * 10 - Math.random() * 10)+'%',
        y: (50 + Math.random() * 10 - Math.random() * 10)+'%',
      },
      {
        duration:0.2,
        scale:(1.0 + (Math.random()*0.15) - Math.random()*0.15),
        rotation: Math.random()*10 - Math.random()*10,
        x: (-350 + Math.random() * 50 - Math.random() * 50)+'%',
        y: (-150 + Math.random() * 50 - Math.random() * 50)+'%',
        ease: 'power2.in',
      });

      rightAnswerTimeline.fromTo(qcSparkle2.value, {
        scale: (0.5 + (Math.random()*0.2) - Math.random()*0.2),
        rotation: 0,
        x: (0 + Math.random() * 50 - Math.random() * 50)+'%',
        y: (50 + Math.random() * 10 - Math.random() * 10)+'%',
      },
      {
        duration:0.2,
        scale:(1.0 + (Math.random()*0.25) - Math.random()*0.25),
        rotation: Math.random()*10 - Math.random()*10,
        x: (200 + Math.random() * 80 - Math.random() * 80)+'%',
        y: (sparkle2EndY + Math.random() * 50 - Math.random() * 50)+'%',
        ease: 'power2.in',
      }, '-=0.2');

      rightAnswerTimeline.fromTo(qcSparkle3.value, {
        scale: (0.5 + (Math.random()*0.2) - Math.random()*0.2),
        rotation: 0,
        x: (0 + Math.random() * 10 - Math.random() * 10)+'%',
        y: (50 + Math.random() * 10 - Math.random() * 10)+'%',
      },
      {
        duration:0.2,
        scale:(1.0 + (Math.random()*0.25) - Math.random()*0.25),
        rotation: Math.random()*10 - Math.random()*10,
        x: (200 + Math.random() * 50 - Math.random() * 50)+'%',
        y: (-250 + Math.random() * 50 - Math.random() * 50)+'%',
        ease: 'power2.in',
      }, '-=0.2');

      rightAnswerTimeline.fromTo(qcSparkle4.value, {
        scale: (0.5 + (Math.random()*0.2) - Math.random()*0.2),
        rotation: 0,
        x: (0 + Math.random() * 10 - Math.random() * 10)+'%',
        y: (50 + Math.random() * 10 - Math.random() * 10)+'%',
      },
      {
        duration:0.2,
        scale:(1.0 + (Math.random()*0.25) - Math.random()*0.25),
        rotation: Math.random()*10 - Math.random()*10,
        x: (-250 + Math.random() * 50 - Math.random() * 50)+'%',
        y: (200 + Math.random() * 50 - Math.random() * 50)+'%',
        ease: 'power2.in',
      }, '-=0.2');

      rightAnswerTimeline.fromTo(qcMemorizeMisfitGummie.value, {scale:0.8}, {duration: 0.75, scale:1.0, ease:'elastic.out(2.5, 0.5)'}, '-=0.1');


      // rightAnswerTimeline.timeScale(0.2);
      rightAnswerTimeline.restart();
    }

    // const beforeEnter = (el) => {
    //   console.log(NAMESPACE, 'beforeEnter');
    // }
    //
    // const beforeLeave = (el) => {
    //   console.log(NAMESPACE, 'beforeLeave');
    // }

    // const enter = (el, done) => {
    //   console.log(NAMESPACE, 'enter');
    //
    //   done();
    // }
    //
    // const leave = (el, done) => {
    //   console.log(NAMESPACE, 'leave');
    //
    //   done();
    // }

    return {
      // Properties
      quizFlavorOutlineImage,
      quizStateMemorize,
      quizStateSelect,
      quizStateTryAgain,
      currentQuizState,
      misfit,
      timerLeft,
      timerIntervalId,

      flavorOne,
      flavorTwo,
      flavorQuizOptions,
      pickedFlavors,
      pickedFlavorOneWrongOverlayStyle,
      pickedFlavorTwoWrongOverlayStyle,

      quizCorrect,
      quizEnded,

      // References
      quizView,
      quizContentViewEl,
      qcSelect,
      qcMemorize,
      qcTryAgain,
      qcSelectAnimationContainer,
      qcMemorizeAnimationContainer,
      qcTryAgainAnimationContainer,
      qcSelectQuizAnimationContainer,
      qcSelectSorryAnimationContainer,

      flavorOptions,
      pickedFlavorOneEl,
      pickedFlavorTwoEl,
      qcMemorizeMisfitGummie,
      qcSparkle1,
      qcSparkle2,
      qcSparkle3,
      qcSparkle4,


      // Methods
      getMisfitFlavor,
      isFlavorSelected,
      handleMemorizeNextBtnClicked,
      handleSelectNextBtnClicked,
      handleTryAgainStartOverBtnClicked,
      handleFlavorClicked,

      // beforeEnter,
      // beforeLeave,
      // enter,
      // leave,
    }
  },
}

</script>

<style lang="scss" scoped>
$flavor-image-padding: 5%;
$padding-top: 150px;
$mobile-padding-top: 18vh;
$mobile-height-short-padding-top: 16vh;

.quiz-view {
  padding-top: #{$padding-top};
}

.quiz-content-view {
  // position: relative;
  // width: 60%;
  // max-width: 800px;
  // min-height: calc(var(--vh, 1vh) * 100 - #{$padding-top});
  font-size: 2rem;
  height: calc(#{$min-height} - #{$padding-top});
}

.qc-misfit-type {
  position: relative;
  color: $font-dark-blue-color;
  @include font-knewave;
  // font-size: 2.5rem;
  font-size: 1.25em;
  padding-top: 1em;
  transform: rotate3d(0, 0, 1, -9deg);
}

.qc-time {
  position: relative;
  color: #2fbee7;
  font-size: 1.1em;
  width: 3.0em;
  margin: 0.2em auto 0 auto;
  @include font-knewave;

  @include bg-image(100, 100);

  // &::before {
  //   display: block;
  //   padding-top: 100%;
  //   content: '';
  // }
}

.qc-time-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/images/quiz/quiz_timer_bg.png');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.qc-time-label {
  position: absolute;
  top: 50%;
  text-align: center;
  width: 100%;
  transform: translateY(-50%);
}

.qc-content {
  position: relative;
}

.qc-content-animation-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.qc-select-content {
  position: relative;
}

.qc-select-animation-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.qc-memorize-gummie-sparkle {
  position: absolute;
  top: 0;
  left: 0%;
  width: 100%;
  height: 100%;
}

.qc-sparkle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10%;
  background-size: contain;


  &.qc-sparkle-1 {
    background-image: url('~@/assets/images/particle_sparkle_1.png');
    @include bg-image(50, 72);
  }

  &.qc-sparkle-2 {
    background-image: url('~@/assets/images/particle_sparkle_2.png');
    @include bg-image(36, 49);
  }
}

.qc-memorize-misfit-gummie {
  position: relative;
  width: 50%;
  margin: -3% auto 0 auto;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @include bg-image(600, 500);

  // &::before {
  //   content: '';
  //   display: block;
  //   width: 100%;
  //   padding-top: calc(100%;
  // }
}

.qc-content-label {
  position: relative;
  font-size: 0.75em;
  font-weight: 700;
  width: 64%;
  margin: -0.01em auto 0 auto;
  text-align: center;
}

.qc-memorize-question, .qc-select-picked-flavors-container {
  // display: inline-block;
  position: relative;
  width: 70%;
  margin: 1.25em auto 0 auto;
  display: flex;
  // align-items: center;
  justify-content: center;
}


.qc-flavor-container {
  position: relative;
  // display: inline-block;
  width: 44%;
  max-width: 160px;

  &.selected {
    .qc-flavor-image {
      // top: #{$flavor-image-padding};
      // left: #{$flavor-image-padding};
      opacity: 0.7;

      &::before {
        display: none;
      }

      &::after {
        display: block;
      }

      img {
        // top: #{$flavor-image-padding};
        // left: #{$flavor-image-padding};
        transform: translate3d(#{$flavor-image-padding}, #{$flavor-image-padding}, 0);
      }
    }
  }

  &.wrong {
    .qc-flavor-image {
      img {
        filter: grayscale(1);
      }
    }

    .qc-flavor-wrong-black-overlay {
      display: block;
    }

    .qc-flavor-wrong-overlay {
      display: block;
    }
  }
}

.qc-flavor-image {
  position: relative;
  width: 90%;
  margin: 0 auto;

  &::before, &::after {
    position: absolute;
    display: block;
    content: '';
    width: 100%;
    padding-top: 100%;
    top: #{$flavor-image-padding};
    left: #{$flavor-image-padding};
    border-radius: 50%;
    background-color: $bg-shadow-blue-color;
  }

  &::after {
    display: none;
    // top: 0;
    // left: 0;
    background-color: transparent;
    background-image: url('~@/assets/images/flavor_selected_inner_shadow.png');
    background-size: cover;
    // opacity: 0.28;
  }

  img {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

}

.qc-flavor-wrong-black-overlay {
  position: absolute;
  top: 2%;
  left: 7%;
  width: 86%;
  height: 92%;
  background-color: #000;
  opacity: 0.5;
  border-radius: 50%;
  display: none;
}

.qc-flavor-wrong-overlay {
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  height: 100%;
  background-image: url('~@/assets/images/quiz/quiz_flavor_wrong_slash.png');
  background-repeat: no-repeat;
  background-size: contain;
  display: none;
}

.qc-memorize-flavor-label {
  position: relative;
  font-size: 0.8em;
  font-weight: 700;
  margin: 0.8em 0 0 0;
}

.qc-memorize-flavor-plus {
  position: relative;
  // display: inline-block;
  font-size: 1.6em;
  font-weight: 700;
  margin: 12% 0.1em 0 0.1em;

  &.qc-select-flavor-plus {

  }
}

.qc-select {

}


.qc-select-flavors {
  display: flex;
  width: 80%;
  margin: 0.6em auto 0 auto;
}

.qc-select-flavor-item {

}

.qc-select-picked-flavors-container {
  width: 60%;
}

.qc-try-again {

}

.qc-try-again-misfit-gummie {
  position: relative;
  width: 76%;
  margin: 3% auto 0 auto;

  img {
    width: 100%;
  }
}

$start-over-btn-padding: 0.2em;

.qc-try-again-label {
  position: relative;
  text-align: center;
  @include font-knewave;
  font-size: 1.2em;
  margin: 1em auto 0 auto;
  line-height: 1em;
}

.start-over-btn {
  position: absolute;
  bottom: 2.5rem;
  font-size: 1.0em;
  left: 50%;
  transform: translateX(-50%);
  // margin: 3em auto 0 auto;
  padding-top: calc(0.5em + #{$start-over-btn-padding});
  padding-bottom: calc(0.5em + #{$start-over-btn-padding});
  padding-left: calc(1.1em + #{$start-over-btn-padding});
  padding-right: calc(1.1em + #{$start-over-btn-padding});
}

.next-btn {
  position: absolute;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
}


// Animation
.fade-enter-active {
  // animation: fade-in 5s;
  transition: opacity 0.2s, transform 0.25s;
  // transition: opacity 0.5s;
}
.fade-leave-active {
  // animation: fade-out 5s;
  transition: opacity 0.2s, transform 0.25s;
  // transition: opacity 0.5s;
}
.fade-enter {
  opacity: 0;
  transform: translateX(100%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.fade-enter-to, .fade-leave {
  opacity: 1;
  transform: translateX(0);
}

@include desktop-medium {

  .qc-flavor-container {
    width: 45%;
    max-width: 140px;
  }
}

@include desktop-small {

}

@include height-medium {
  .quiz-content-view {
    font-size: 2.0rem;
  }


}

@include height-short {
  .quiz-content-view {
    font-size: 1.8rem;
  }
}

@include mobile {
  .quiz-view {
    padding-top: $mobile-padding-top;
  }

  // .quiz-content-view {
  //   width: 100%;
  //   // min-height: calc(var(--vh, 1vh) * 100 - 20vh);
  // }

  .quiz-content-view {
    font-size: 1.8rem;
    height: initial;
    min-height: calc(var(--vh, 1vh) * 100 - #{$mobile-padding-top});
  }

  .qc-time {
    font-size: 1em;
  }

  .qc-memorize-misfit-gummie {
    width: 50%;
  }

  .qc-memorize-question {
    width: 52%;
    margin-top: 1em;
  }

  .qc-content-label {
    font-size: 0.7em;
    width: 60%;
  }

  .qc-select-flavors {
    width: 74%;
  }

  .qc-select-picked-flavors-container {
    width: 54%;
    margin-top: 0.5em;
  }

  .qc-try-again-misfit-gummie {
    width: 40%;
  }

  .qc-try-again-label {
    // font-size: 1em;
  }
}

@include mobile-small {
  .quiz-view {
    // padding-top: 20vh;
  }

  .quiz-content-view {
    font-size: 1.8rem;

  }

  .qc-time {
    font-size: 1em;
  }

  .qc-memorize-misfit-gummie {
    width: 44%;
  }

  .qc-memorize-question {
    width: 52%;
    margin-top: 1em;
  }

  .qc-content-label {
    font-size: 0.7em;
    width: 60%;
  }

  .qc-select-flavors {
    width: 72%;
  }

  .qc-select-picked-flavors-container {
    width: 50%;
    margin-top: 0.5em;
  }

  .qc-try-again-misfit-gummie {
    width: 40%;
  }

  .qc-try-again-label {
    // font-size: 1em;
  }
}

body.touch {
  @include height-medium {

  }

  @include height-short {
    .quiz-view {
      padding-top: #{$mobile-height-short-padding-top};
    }

    .quiz-content-view {
      min-height: calc(var(--vh, 1vh) * 100 - #{$mobile-height-short-padding-top});
      font-size: 1.6rem;
    }

    .qc-memorize-misfit-gummie {
      width: 40%;
    }

    .qc-content-label {
      // font-size: 0.75em;
      width: 48%;
    }

    .qc-select-picked-flavors-container {
      width: 50%;
    }
  }

  @include mobile-aspect-ratio-40-62 {
    .qc-memorize-misfit-gummie {
      width: 40%;
    }

    .qc-memorize-question {
      // width: 50%;
    }

    .qc-select-flavors {
      width: 68%;
    }

    .qc-select-picked-flavors-container {
      width: 50%;
    }
  }

  @include mobile-aspect-ratio-40-59 {
    .quiz-view {

    }

    .quiz-content-view {
      font-size: 1.5rem;
    }

    .qc-memorize-misfit-gummie {
      width: 38%;
    }

    .qc-memorize-question {
      width: 50%;
    }

    .qc-select-flavors {
      width: 64%;
    }

    .qc-select-picked-flavors-container {
      width: 44%;
    }
  }
}

</style>
